import React, { useEffect, useState, useMemo } from "react";
import Popup from "@df-mobile/popup";
import { getQueryString } from "@/utils";
import closeIcon from "./imgs/close_icon.png";
import "./index.less";
import DfSinglePrice from "@df-mobile/df-single-price";
import { useNavigate } from "react-router-dom";

interface BProps {
  visible: boolean;
  noBot?: boolean; // 是否没有底部按钮
  detailInfo?: any;
  callBack?: (type?: string, value?: any) => void;
  icon?: string; // 底部按钮图标
}

const BugKnow = (props: BProps) => {
  const { visible, detailInfo, callBack, noBot, icon } = props;
  const navigate = useNavigate();
  
  const { purchaseNotes } = detailInfo || {};
  const onClose = () => {
    callBack && callBack("close");
  };
  const gotoBuy = () => {
    callBack && callBack("close");
    const sceneryId = getQueryString("sceneryId");
    navigate(
      `/confirm?type=1&dfPackageId=${detailInfo?.dfPackageId}&dfProductId=${detailInfo?.dfProductId}&dfResourceId=${detailInfo?.dfResourceId}&sceneryId=${sceneryId}`
    );
  };
  if (!visible || !Object.keys(detailInfo)?.length) return null;
  return (
    <Popup
      visible={visible}
      destroyOnClose
      position="bottom"
      wrapClassName="buyBottomPopup"
      onClose={onClose}
    >
      <div className={`buy-content-wrapper ${noBot?'pad-none':''}`}>
        <div className="header-top">
          {detailInfo?.ticketName && <div>{detailInfo?.ticketName}</div>}
          <span onClick={onClose}>
            <img src={closeIcon} alt="" />
          </span>
        </div>

        <div className="buy-pop-content">
          <div className="card-part-wrapper">
            <div className="card-name">预订须知</div>
            {purchaseNotes?.usageTime && (
              <div className="common-flex marT-10">
                <div className="blue-label">使用时长</div>
                <div
                  className="content-tip"
                  dangerouslySetInnerHTML={{ __html: purchaseNotes?.usageTime }}
                ></div>
              </div>
            )}
            {purchaseNotes?.confirmTime && (
              <div className="common-flex marT-10">
                <div className="blue-label">确认时长</div>
                <div
                  className="content-tip"
                  dangerouslySetInnerHTML={{
                    __html: purchaseNotes?.confirmTime,
                  }}
                ></div>
              </div>
            )}
            {purchaseNotes?.bookingEffectiveTimeDescription && (
              <div className="common-flex marT-10">
                <div className="blue-label">预订生效时间</div>
                <div
                  className="content-tip"
                  dangerouslySetInnerHTML={{
                    __html: purchaseNotes?.bookingEffectiveTimeDescription,
                  }}
                ></div>
              </div>
            )}
            {purchaseNotes?.refundDescription && (
              <div className="common-flex marT-10">
                <div className="blue-label">退改规则</div>
                <div
                  className="content-tip"
                  dangerouslySetInnerHTML={{
                    __html: purchaseNotes?.refundDescription,
                  }}
                ></div>
              </div>
            )}
            {purchaseNotes?.saleAloneType && (
              <div className="common-flex marT-10">
                <div className="blue-label">是否可单独售卖</div>
                <div
                  className="content-tip"
                  dangerouslySetInnerHTML={{
                    __html: purchaseNotes?.saleAloneType,
                  }}
                >
                  {}
                </div>
              </div>
            )}
            {purchaseNotes?.rangeType && (
              <div className="common-flex marT-10">
                <div className="blue-label">产品使用条件</div>
                <div
                  className="content-tip"
                  dangerouslySetInnerHTML={{ __html: purchaseNotes?.rangeType }}
                ></div>
              </div>
            )}
          </div>
          {purchaseNotes &&
            (purchaseNotes?.inclusion || purchaseNotes?.exclusion) && (
              <div className="card-part-wrapper">
                <div className="card-name">费用说明</div>
                {purchaseNotes?.inclusion && (
                  <div className="common-flex marT-10">
                    <div className="gray-title">费用包含</div>
                    <div
                      className="content-tip"
                      dangerouslySetInnerHTML={{
                        __html: purchaseNotes?.inclusion,
                      }}
                    ></div>
                  </div>
                )}
                {purchaseNotes?.exclusion && (
                  <div className="common-flex marT-10">
                    <div className="gray-title">费用不包含</div>
                    <div
                      className="content-tip"
                      dangerouslySetInnerHTML={{
                        __html: purchaseNotes?.exclusion,
                      }}
                    ></div>
                  </div>
                )}
              </div>
            )}
          {purchaseNotes?.attention && (
            <div className="card-part-wrapper">
              <div className="card-name">注意事项</div>
              <div
                className="marT-10 content-tip"
                dangerouslySetInnerHTML={{
                  __html: purchaseNotes?.attention,
                }}
              ></div>
            </div>
          )}
          {purchaseNotes?.instruction && (
            <div className="card-part-wrapper">
              <div className="card-name">使用方法</div>
              <div
                className="marT-10 content-tip"
                dangerouslySetInnerHTML={{
                  __html: purchaseNotes?.instruction,
                }}
              ></div>
            </div>
          )}
        </div>
      </div>
      {!noBot && (
        <div className="bottom-wrapper">
          {/* <DfSinglePrice
            price={detailInfo?.salesPrice || undefined}
            priceSize="XL18"
            icon={icon}
          /> */}
          <div className="submit-button" onClick={gotoBuy}>
            立即预订
          </div>
        </div>
      )}
    </Popup>
  );
};

export default BugKnow;
